import cx from 'classnames';
import styles from '../components/Icons/Icons.module.scss';
import ExclamationMarkIcon from './raw/exclamation-mark.svg?react';
import type { IconProps } from './types';

const ExclamationMark = ({
  className,
  iconClass = true,
  label,
  style,
  viewBox,
}: IconProps) => (
  <ExclamationMarkIcon
    title={label}
    aria-labelledby={label}
    xmlns="http://www.w3.org/2000/svg"
    shapeRendering="geometricPrecision"
    viewBox={viewBox || '-6 -2 16 16'}
    className={cx({
      [styles.svgIcon]: iconClass,
      ...(className
        ? {
            [styles[className]]: className && styles[className],
            [className]: className && !styles[className],
          }
        : {}),
    })}
    style={style}
  />
);

export default ExclamationMark;
